"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var memoize_one_1 = require("memoize-one");
var metrics_engine_1 = require("@tableau/metrics-engine");
var formatting_1 = require("./formatting/formatting");
var styles_1 = require("./styles/styles");
var widgets_1 = require("@tableau/widgets");
var TimeSeriesInteractiveLayer_1 = require("./TimeSeriesInteractiveLayer");
var react_sizeme_1 = require("react-sizeme");
var victory_1 = require("victory");
// We have to define this here in order to have axis labels render in the correct font.
// Since they are SVGs, they don't inherit styles like the rest of the text elements do.
var fontFamily = 'Benton Sans';
var DetailTimeSeries = /** @class */ (function (_super) {
    __extends(DetailTimeSeries, _super);
    function DetailTimeSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderChart = function () {
            var height = _this.props.size.height;
            var width = _this.props.size.width;
            var domainAndRange = _this.calculateDomainAndRange(_this.props.data, height, width);
            if (!domainAndRange) {
                return null;
            }
            var domain = domainAndRange.domain, range = domainAndRange.range;
            return (React.createElement(React.Fragment, null,
                React.createElement(victory_1.VictoryChart, { scale: { x: 'time', y: 'linear' }, height: height, width: width, padding: chartPadding, domain: domain, range: range, containerComponent: React.createElement(victory_1.VictoryContainer, { responsive: false, style: {
                            labels: { fill: 'none' },
                        } }) },
                    React.createElement(victory_1.VictoryAxis, { crossAxis: false, style: {
                            tickLabels: {
                                fill: widgets_1.TabStyles.Typography.Color.PrimaryMedium,
                                fontSize: '12px',
                                fontFamily: fontFamily,
                                fontWeight: 800,
                            },
                            axisLabel: { fill: widgets_1.TabStyles.Colors.L7 },
                            axis: { stroke: 'none' },
                        }, standalone: false, offsetY: X_AXIS_HEIGHT, fixLabelOverlap: true, orientation: 'bottom', range: range, tickFormat: formatting_1.dateTickFormat }),
                    React.createElement(victory_1.VictoryAxis, { dependentAxis: true, crossAxis: false, name: 'y-axis', tickLabelComponent: React.createElement(victory_1.VictoryLabel, { dy: -8, dx: Y_AXIS_WIDTH }), tickFormat: _this.formatTick, style: {
                            grid: { stroke: styles_1.MetricBlueLight },
                            tickLabels: {
                                fill: widgets_1.TabStyles.Typography.Color.PrimaryMedium,
                                fontSize: '12px',
                                fontFamily: fontFamily,
                            },
                            axis: { stroke: 'none' },
                        }, offsetX: chartPadding.left, range: range }),
                    React.createElement(victory_1.VictoryLine, { data: _this.props.data, name: 'line', x: 'timestamp', y: 'measure', style: {
                            data: {
                                stroke: styles_1.MetricBlue,
                                strokeWidth: 2,
                            },
                            labels: { fill: widgets_1.TabStyles.Colors.L7 },
                        } })),
                React.createElement(TimeSeriesInteractiveLayer_1.TimeSeriesInteractiveLayer, { data: _this.props.data, dateTrunc: _this.props.dateTrunc, domain: domain, size: _this.props.size, padding: dataAreaPadding, onDataPointActivated: _this.handleActivated })));
        };
        _this.formatTick = function (value) {
            return formatting_1.formatValueAsMetricNumber(value, _this.props.formatString);
        };
        // This function calculates the adjusted domain and ranges to use for chart,
        // and is memoized to avoid recomputing when the data and size haven't
        // changed.
        // No typedef because I'd just have to repeat the signature twice.
        // tslint:disable-next-line: typedef
        _this.calculateDomainAndRange = memoize_one_1.default(function (data, height, width) {
            var dataHeight = height - dataAreaPadding.top;
            var timeDomain = metrics_engine_1.timeDomainToRender(data);
            var measureDomain = metrics_engine_1.measureDomainToRender(data);
            var measureRange = [dataHeight, dataAreaPadding.top];
            var timeRange = [dataAreaPadding.left, width - dataAreaPadding.right];
            return timeDomain[0] === undefined
                ? undefined
                : {
                    domain: { x: timeDomain, y: measureDomain },
                    range: { x: timeRange, y: measureRange },
                };
        });
        _this.handleActivated = function (point) {
            if (_this.props.onActivated) {
                _this.props.onActivated(point);
            }
        };
        return _this;
    }
    DetailTimeSeries.prototype.render = function () {
        return (React.createElement("div", { style: {
                position: 'relative',
                height: '100%',
            } },
            React.createElement("div", { "data-tb-test-id": this.props.testId || 'detail-time-series', style: __assign({}, this.props.style, { width: '100%', height: '100%', position: 'absolute', WebkitTouchCallout: 'none', WebkitUserSelect: 'none' }) }, this.renderChart())));
    };
    DetailTimeSeries.prototype.shouldComponentUpdate = function (nextProps) {
        return this.props.data !== nextProps.data ||
            this.props.size.width !== nextProps.size.width ||
            this.props.size.height !== nextProps.size.height;
    };
    return DetailTimeSeries;
}(React.Component));
exports.DetailTimeSeries = DetailTimeSeries;
exports.ResizableDetailTimeSeries = react_sizeme_1.withSize({ monitorHeight: true, monitorWidth: true })(DetailTimeSeries);
var chartPadding = {
    top: 30,
    left: 5,
    right: 0,
    bottom: 0,
};
var Y_AXIS_WIDTH = 40;
var X_AXIS_HEIGHT = 30;
var RIGHT_DATA_MARGIN = 40;
var dataAreaPadding = {
    top: chartPadding.top,
    left: chartPadding.left + Y_AXIS_WIDTH,
    right: chartPadding.right + RIGHT_DATA_MARGIN,
    bottom: chartPadding.bottom + X_AXIS_HEIGHT,
};
//# sourceMappingURL=DetailTimeSeries.js.map